import * as React from 'react';
import { styled } from 'styled-components';

import { Button, Icon, Modal, tk } from '@sunwebgroup/ui-components';

import * as LiveSearch from './Primitives';
import { useIntl } from '@/intl';

export const LiveSearchMobile = () => {
  const intl = useIntl();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      <Trigger $hierarchy="tertiary" $withoutColor onClick={handleOpen}>
        <Icon glyph="IconSearch" />
      </Trigger>
      <Modal.Root open={open} onClose={handleOpen}>
        <Modal.Content $size="sm">
          <Modal.Header>
            <LiveSearch.Header />
          </Modal.Header>
          <Body>
            <BodyWrapper>
              <LiveSearch.Loader />
              <LiveSearch.Body />
              <LiveSearch.NoResults />
            </BodyWrapper>
          </Body>
          <Footer>
            <Button $hierarchy="tertiary" $withoutColor onClick={handleOpen}>
              {intl.formatMessage({ id: 'live-search_cancel' })}
            </Button>
          </Footer>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};

const Trigger = styled(Button)`
  &:hover {
    color: ${tk('color_semantic_text_primary_hover')};
  }
`;

const Footer = styled(Modal.Footer)`
  display: flex;
  justify-content: flex-end;

  ${Button} {
    flex-grow: 0;
  }
`;

const Body = styled(Modal.Body)`
  background: ${tk('color_semantic_bg')};
`;

const BodyWrapper = styled.div`
  padding: ${tk('spacing_md')};
  padding-top: 0;
  height: 100%;
`;
